const todos = {
  8: ['AV'],
  9: ['CE'],
  10: ['CE'],
  11: ['IV'],
  12: ['nao_definido'],
  13: ['CR'],
  14: ['DD'],
  15: ['PC'],
  17: ['PV'],

  20: ['UE'],
  21: ['CT'],
  22: ['RB'],

  // Escritura com valor declarado:
  101: ['ES', 'TR'],
  102: ['ES', 'TR'],
  103: ['ES', 'TR'],
  104: ['ES', 'TR'],
  105: ['ES', 'TR'],
  106: ['ES', 'TR'],
  107: ['ES', 'TR'],
  108: ['ES', 'TR'],
  109: ['ES', 'TR'],
  110: ['ES', 'TR'],
  111: ['ES', 'TR'],
  112: ['ES', 'TR'],
  113: ['ES', 'TR'],
  114: ['ES', 'TR'],
  115: ['ES', 'TR'],
  116: ['ES', 'TR'],
  117: ['ES', 'TR'],
  118: ['ES', 'TR'],
  119: ['ES', 'TR'],
  120: ['ES', 'TR'],
  121: ['ES', 'TR'],
  122: ['ES', 'TR'],
  123: ['ES', 'TR'],
  124: ['ES', 'TR'],
  125: ['ES', 'TR'],
  126: ['ES', 'TR'],
  127: ['ES', 'TR'],
  128: ['ES', 'TR'],
  129: ['ES', 'TR'],
  130: ['ES', 'TR'],
  131: ['ES', 'TR'],
  132: ['ES', 'TR'],
  133: ['ES', 'TR'],
  134: ['ES', 'TR'],
  135: ['ES', 'TR'],

  // Procuração, substabelecimento ou revogação
  136: ['PR', 'TR'],
  137: ['PR', 'TR'],
  138: ['PR', 'TR'],
  139: ['PR', 'TR'],
  140: ['PR', 'TR'],
  141: ['PR', 'TR'],
  142: ['PR', 'TR'],
  143: ['PR', 'TR'],

  // Autenticação de cópias de documentos extraídas por meio reprográfico (por página)
  144: ['AU'],
  162: ['LC'],

  // Reconhecimento de Firma, inclusive letras e sinal
  145: ['S1'],
  146: ['S2'],
  147: ['C1'],
  148: ['C2'],
  149: ['RA'],
  150: ['CE'],

  // Escritura sem valor declarado
  151: ['ES', 'TR'],
  152: ['ES', 'TR'],

  // Registro chancela mecânica
  153: ['CM'],

  // Testamento
  154: ['TE'],
  155: ['TE'],
  156: ['TE'],
  157: ['TE'],

  // Atas Notariais, sem reflexo econômico
  158: ['AN', 'TR'],
  159: ['AN', 'TR'],

  // Escritura de Convenção de Condomínio
  160: ['ES', 'TR'],

  // Apostilamento
  161: ['AP'],
}

const custas = {
  todos,
  habilitacao: {
    1: ['HC'],
    2: ['HC'],
    3: ['HC'],
    4: ['AC'],
    5: ['AC', 'PV'],
    6: ['EP'],
    ...todos
  },
  casamento: {
    4: ['AC'],
    5: ['AC', 'PV'],
    18: ['AC'],
    ...todos
  },
  livro_e: {
    7: ["LE", "PV"],
    ...todos
  },
  nascimento: {
    16: ["AN", "PV"],
    ...todos
  },
  obito: {
    16: ["AO", "PV"],
    ...todos
  },
  natimorto: {
    16: ["NT", "PV"],
    ...todos
  },
  duplos: [5,7,16],
  traslado: [...obterCodComAto('ES'), ...obterCodComAto('PR'), ...obterCodComAto('AN')],
  impressos: [9, 10, 161, 162, 163, 144, 145, 146, 147, 148, 149, 150, 5,7,16, ...obterCodComAto('ES'), ...obterCodComAto('PR'), ...obterCodComAto('AN')],
  selosFisicos: ['RA', 'AU', 'S1', 'S2', 'C1', 'C2'] //  [144,145,146,147,148,149]
}

// usado em Ato de selagem dupla para criar o vínculo automático dos selos, adicionar o Ato aqui sempre que surgir um duplo
const siglaSeloAtoVinculador = ['ES', 'PR', 'AN', 'AC', 'LE', 'AN', 'AO', 'NT']
const siglaAtoSeloVinculado = ['TR', 'PV']

export const optionsRegistro = [
  { text: 'Outros', value: 'todos' },
  { text: 'Nascimento', value: 'nascimento' },
  { text: 'Habilitação de casamento', value: 'habilitacao' },
  { text: 'Casamento', value: 'casamento' },
  { text: 'Óbito', value: 'obito' },
  { text: 'Natimorto', value: 'natimorto' },
  { text: 'Livro E', value: 'livro_e' },
]

export const optionsRegistroAtosNotariais = [
  { text: 'Outros', value: 'todos' },
  { text: 'Procuração', value: 'procuracao' },
  { text: 'Escrituras', value: 'escrituras' },
  { text: 'Firmas', value: 'firmas' },
  { text: 'Autenticação', value: 'autenticacao' },
  { text: 'Testamentos', value: 'testamentos' }
]

export function obterSeloAtoVinculador () {
  return siglaSeloAtoVinculador
}

export function obterAtoSeloVinculado () {
  return siglaAtoSeloVinculado
}

function obterCodComAto (sigla) {
  const codigos = []

  for (const key in todos) {
    if (todos[key].includes(sigla)) {
      codigos.push(Number(key))
    }
  }

  return codigos
}

export function obterAtosComCodigo (cod, tipoRegistro = null) {
  let grupo = null

  if (!!tipoRegistro) {
    switch (tipoRegistro) {
      case 'O':
        grupo = 'obito'
      break

      case 'NT':
        grupo = 'natimorto'
      break

      case 'N':
        grupo = 'nascimento'
      break

      case 'D':
        grupo = 'habilitacao'
      break

      case 'E':
        grupo = 'livro_e'
      break

      case 'C': case 'CR':
        grupo = 'casamento'
      break
      }

  const propriedade = custas[grupo]

  if (propriedade[cod]) {
    return propriedade[cod]
  }
  } else {
    for (const key in custas) {
    const propriedade = custas[key]
    if (propriedade[cod]) {
       return propriedade[cod]
    }
  }
  }
}


export function obterTodosCods () {
  const result = {}

  for (const key in custas) {
    if (custas.hasOwnProperty(key)) {
      if (typeof custas[key] === 'object' && !Array.isArray(custas[key])) {
        const flattenedSubObj = obterTodosCods(custas[key])
        for (const subKey in flattenedSubObj) {
          if (flattenedSubObj.hasOwnProperty(subKey)) {
            result[subKey] = flattenedSubObj[subKey]
          }
        }
      } else {
        result[key] = custas[key]
      }
    }
  }
  return result
}

export default custas
